import { colors } from '@mui/material';
import { PaletteOptions } from '@mui/material/styles/createPalette';

const { white, black } = colors.common;

export default <PaletteOptions>{
  black,
  white,
  background: {
    dark: '#F4F6F8',
    default: white,
    paper: white,
  },
  primary: {
    light: colors.indigo[100],
    main: colors.indigo[500],
    dark: colors.indigo[900],
    contrastText: white,
  },
  secondary: {
    main: colors.indigo[500],
  },
  text: {
    primary: colors.blueGrey[900],
    secondary: colors.blueGrey[600],
    // link: colors.blue[600],
  },
  success: {
    contrastText: white,
    dark: colors.green[900],
    main: colors.green[700],
    light: colors.green[400],
  },
  info: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue[600],
    light: colors.blue[400],
  },
  warning: {
    contrastText: white,
    dark: colors.orange[900],
    main: colors.orange[600],
    light: colors.orange[400],
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[500],
    light: colors.red[400],
  },
  icon: colors.blueGrey[600],
  divider: colors.grey[200],
};
